var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"components order-btn"},[_c('img',{staticClass:"order-img",attrs:{"src":require('@/assets/icons/icon-order-btn.png')},on:{"click":_vm.toOrderList}}),_c('div',{staticClass:"text"},[_vm._v("订单")])])}
var staticRenderFns = []

export { render, staticRenderFns }